<template>
  <v-card>
    <v-card-title>
      Categories
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="user.admin== true ? headers : managerHeaders"
      :items="categories"
      :search="search"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.category }}</td>
        <td>
          <v-btn
            color="btnColor"
            @click="showSubCategoryModal(props.item.subcategories)"
            flat
          >View Subcategories</v-btn>
        </td>
        <td>
          <v-btn icon @click="editModal(props.item)">
            <v-icon color="orange darken-2">edit</v-icon>
          </v-btn>
        </td>
        <td v-if="user.admin == true">
            <v-btn icon @click="deleteCatModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- Sub categories dialog -->
    <v-dialog v-model="subModal" max-width="700px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Sub Categories</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click="close">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-data-table :headers="subcategoryHeaders" :items="subcategories">
          <template v-slot:items="props">
            <td>{{ props.item }}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- End of sub categories modal -->

    <!-- Category editing -->
    <v-dialog v-model="editDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Edit Category</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="editDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs4>
                <v-text-field v-model="editItem.title" label="Title"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="editItem.category" label="Category"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="editItem.url" label="Url"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="H1 Title" v-model="editItem.h1_title"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <ckeditor v-model="editItem.description" id="description"
                  data-vv-name="description"  label="Description" :editor="editor" :config="editorConfig"></ckeditor>
              </v-flex>
              <v-flex xs12>
                <v-data-table :headers="esubcategoryHeaders" :items="editItem.subcategories">
                  <template v-slot:items="props">
                    <td>{{ props.item }}</td>
                    <td>
                      <v-btn icon @click="editSubCategory(props.item)">
                        <v-icon color="orange darken-2">edit</v-icon>
                      </v-btn>
                    </td>
                    <td v-if="user.admin == true">
                      <v-btn icon @click="deleteModal(props.item)">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn class="primary" @click="save" :loading="loading">
                  <v-icon left>save</v-icon>Save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End -->

    <!-- option dialog -->
    <v-dialog v-model="subDialog" max-width="500px">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Sub Category</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="subDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12>
            <v-text-field v-model="subItem" label="Sub Category"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" dark :loading="loading" @click="updateSub">Update</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of option dialog-->

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Blog</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this category?</h5>
            </v-flex>

            <v-flex xs12>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Slug" v-model="dataItem.category"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Video Title" v-model="dataItem.url"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteCategory" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->

  </v-card>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { mapGetters } from "vuex";

export default {
  components: {
    CKEditor,
  },
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    categories: {
      type: Array,
      default: [],
      required: true
    }
  },
  data() {
    return {
      search: "",
      editDialog: false,
      editItem: {},
      subModal: false,
      loader: false,
      loading: false,
      subItem: null,
      csubItem: null,
      subDialog: false,
      subcategories: [],
      pagination: {
        rowsPerPage: 10
      },
      headers: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: "Category",
          align: "left",
          sortable: false,
          value: "category"
        },
        {
          text: "Sub Categories",
          align: "left",
          sortable: false,
          value: "sub"
        },
        { text: "Action", value: "Edit" },
        { text: "Delete", value: "Delete" }
      ],
      managerHeaders: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: "Category",
          align: "left",
          sortable: false,
          value: "category"
        },
        {
          text: "Sub Categories",
          align: "left",
          sortable: false,
          value: "sub"
        },
        { text: "Action", value: "Edit" },
      ],
      subcategoryHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],
      esubcategoryHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Action",
          align: "left",
          value: "edit"
        },
        {
          text: "Action",
          align: "left",
          value: "delete"
        }
      ],
      dataItem: {},
      delete_dialog: false,
      editor: ClassicEditor,
      editorConfig: {
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        },
        link: { addTargetToExternalLinks: true },
      },
    };
  },
  methods: {
    editModal(data) {
      this.editItem = Object.assign({}, data);
      this.editDialog = true;
    },
    editSubCategory(data) {
      this.subItem = data;
      this.csubItem = data;
      this.subDialog = true;
    },
    deleteModal(data) {
      const index = this.editItem.subcategories.indexOf(data);
      this.editItem.subcategories.splice(index, 1);
    },
    deleteCatModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    save() {
      const data = this.editItem;
      this.loading = true;
      const self = this;
      this.$store
        .dispatch("post", { data: data, url: "/expertise/update" })
        .then(res => {
          self.loading = false;
          location.reload();
        });
    },
    updateSub() {
      const i = [...this.editItem.subcategories];
      const csubItem = this.csubItem;
      const subItem = this.subItem;
      const index = this.editItem.subcategories.indexOf(csubItem);
      if (index === -1) {
        return;
      }
      i[index] = subItem;
      this.editItem.subcategories = i;
      this.subDialog = false;
    },
    showSubCategoryModal(items) {
      this.subcategories = items;
      this.subModal = true;
    },
    close() {
      this.subModal = false;
    },
    deleteCategory() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/expertise/delete", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
  }
};
</script>